import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    from: 'from',
    periods: {
      custom: 'Custom period',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      yearly: 'Yearly',
    },
    to: 'to',
  },
  fr: {
    from: 'du',
    periods: {
      custom: 'Période personnalisée',
      monthly: 'Mois',
      quarterly: 'Trimestre',
      yearly: 'Année',
    },
    to: 'au',
  },
} as const);

export default locales;
